<a class="underline text-actionable-primary" href="mailto:{{supportEmail}}">{{supportEmail}}</a>